import InputCouponModal from "./input-coupon-modal.component";

export default InputCouponModal;
